import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addBank, updateBank } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function BankCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    name: state?.name || "",
    category: state?.category || "",
    status: state?.status || true,
  });
  const [errors, setErrors] = useState({
    name: "",
    category:"",
    status: "",
  });

    useEffect(() => {
      if (state) {
        setInput(prevState => ({
          ...prevState,
          status: state?.status,
        }));
      }
    }, [state]);

   

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const bankCategoryList = [
    { label: "Nationalised Bank", value: "Nationalised bank" },
    { label: "Private Bank", value: "Private Bank" },
    { label: "Financial Institution", value: "Financial Institution" },
    { label: "Small Bank", value: "Small Bank" },
    { label: "Alternative Investment Fund", value: "Alternative Investment Fund" },     
  ]

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }
    

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          category: input.category,
          status: input.status,
        };
        updateBank(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/bank/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          category: input.category,
        };
        addBank(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/bank/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/bank/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Bank {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                       Bank Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                     <div className="col-md-6">
                        <label htmlFor="status" className="form-label">
                          Category
                        </label>
                        <Dropdown
                          style={{ width: "100%" }}
                          options={bankCategoryList}
                          value={input.category}
                          onChange={(e) => {
                            setInput({
                              ...input,
                              category: e.value,
                            });
                          }}
                        />
                        <div className="text-danger">{errors.category}</div>
                      </div>
                     
                  </div>
                  
                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
